/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tags: NonNullable<unknown> }} Account_Notifications_Tags_LabelInputs */

const he_account_notifications_tags_label = /** @type {(inputs: Account_Notifications_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`תגיות: ${i?.tags}`)
};

const en_account_notifications_tags_label = /** @type {(inputs: Account_Notifications_Tags_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tags: ${i?.tags}`)
};

/**
* | output |
* | --- |
* | "Tags: {tags}" |
*
* @param {Account_Notifications_Tags_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_tags_label = /** @type {((inputs: Account_Notifications_Tags_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Tags_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_tags_label(inputs)
	return en_account_notifications_tags_label(inputs)
});